// Schedule / Gantt view (wireframe 02) — render_gantt + What-if. The
// envelope's `gantt-data` payload feeds the native GanttWidget directly;
// the view skips the standard ArtifactView so the wireframe-style
// toolbar (legend + counts) sits flush against the chart without an
// intervening "LIVE / git sha" metarow.

import { GanttWidget } from "../components/widgets/GanttWidget.js";
import { useShell } from "../components/ShellContext.js";
import { useTool } from "../lib/useTool.js";
import { ErrorState, Skeleton } from "./common.js";

export default function GanttView() {
  const { project } = useShell();
  const { env, loading, error, refetch } = useTool("render_gantt", { project });

  if (loading) return <Skeleton lines={4} />;
  if (error) return <ErrorState error={error} onRetry={refetch} />;
  if (!env) return <ErrorState error="render_gantt returned no envelope" onRetry={refetch} />;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-lg border border-slate-200 bg-white">
      <GanttWidget data={env.data} title={env.title ?? "Gantt"} />
    </div>
  );
}
